import { useContext, useEffect, useState } from "react";
import { MyContext } from "../context/myContext";
import { useDispatch, useSelector } from "react-redux";
import {
  selectShowInsurance,
  getNomadInsurance,
} from "../features/common-states/commonStatesSlice";

const InsurancePopUp = ({ nomad }) => {
  const dispatch = useDispatch();
  const { title, handleShowInsurance } = useContext(MyContext);
  const showInsurance = useSelector(selectShowInsurance);
  const [insuranceData, setInsuranceData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (nomad?.id && showInsurance) {
      fetchInsurance();
    }
  }, [nomad, showInsurance]);

  const fetchInsurance = async () => {
    setLoading(true);
    try {
      const result = await dispatch(
        getNomadInsurance({ nomad_id: nomad.id }),
      ).unwrap();
      setInsuranceData(result);
    } catch (error) {
      console.error("Error fetching insurance:", error);
      alert("خطا در دریافت اطلاعات بیمه‌نامه");
    } finally {
      setLoading(false);
    }
  };

  // تابع دانلود تصویر
  const downloadImage = async (url, filename) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename || "insurance_image.jpg";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error("Download failed:", error);
      alert("خطا در دانلود تصویر");
    }
  };
  const isImage = (url) => {
    if (!url) return false;
    const ext = url.split(".").pop().toLowerCase();
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
    return imageExtensions.includes(ext);
  };

  return (
    <div
      className={`${showInsurance && "top-[20px]"} popup-styles !px-3 sm:!px-5 w-[95vw]`}
    >
      <div className="flex flex-wrap justify-between items-center gap-x-4 gap-y-2 py-2">
        <i className="fa fa-times close-icon" onClick={handleShowInsurance}></i>
        <div className="text-sm ml-auto border-b border-b-2 py-2">
          <p>{title}</p>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-4">در حال بارگذاری...</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-200">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-4 py-2 border">شناسه</th>
                <th className="px-4 py-2 border">تاریخ انقضا</th>
                <th className="px-4 py-2 border">تصویر</th>
                <th className="px-4 py-2 border">تاریخ ثبت</th>
              </tr>
            </thead>
            <tbody>
              {insuranceData.length > 0 ? (
                insuranceData.map((item, index) => (
                  <tr key={index} className="text-center">
                    <td className="px-4 py-2 border">{item.id}</td>
                    <td className="px-4 py-2 border">{item.expiry}</td>
                    <td className="px-4 py-2 border">
                      {item.imageUrl ? (
                        <div className="flex items-center justify-center gap-2">
                          {isImage(item.imageUrl) ? (
                            // حالت تصویر: نمایش بندانگشتی + دکمه دانلود
                            <>
                              <img
                                src={item.imageUrl}
                                alt="بیمه‌نامه"
                                className="w-16 h-16 object-cover rounded border"
                              />
                              <button
                                onClick={() =>
                                  downloadImage(
                                    item.imageUrl,
                                    `insurance_${item.id}.jpg`,
                                  )
                                }
                                className="text-blue-500 hover:text-blue-700 text-lg"
                                title="دانلود تصویر"
                              >
                                <i className="fa fa-download"></i>
                              </button>
                            </>
                          ) : (
                            // حالت غیرتصویر (مثلاً PDF): فقط دکمه دانلود
                            <button
                              onClick={() =>
                                downloadImage(
                                  item.imageUrl,
                                  `insurance_${item.id}.pdf`,
                                )
                              }
                              className="text-blue-500 hover:text-blue-700 text-lg flex items-center gap-1"
                              title="دانلود فایل"
                            >
                              <i className="fa fa-download"></i>
                              <span>دانلود</span>
                            </button>
                          )}
                        </div>
                      ) : (
                        <span className="text-gray-400">ندارد</span>
                      )}
                    </td>
                    <td className="px-4 py-2 border">{item.created}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="px-4 py-2 text-center">
                    هیچ بیمه‌نامه‌ای یافت نشد
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      <div className="py-3">
        <button
          className="button-styles bg-red-500 hover:bg-red-600 text-xs sm:text-sm"
          onClick={handleShowInsurance}
        >
          بستن
        </button>
      </div>
    </div>
  );
};

export default InsurancePopUp;
